export function waLink(phone, text) {
  let p = (phone || "").replace(/\D/g, "");
  if (p.startsWith("0")) p = `62${p.slice(1)}`;
  return `https://wa.me/${p}?text=${encodeURIComponent(text)}`;
}

export function orderMessage(t, noteOnly = false) {
  const note = (t.driver_note || "").trim();
  if (noteOnly) return note;
  return `${note}\n\nSetelah trip selesai, lengkapi trip di web berikut:\n${window.location.origin}/driver`;
}
